// Trang đích sau đăng nhập / đổi workspace — theo vai trò và theo tenant (không hardcode id tenant).
//  • CTV: chỉ có Timeline.  • Tenant bật HOLA (tenants/{tid}.holaEnabled): chỉ dùng module HOLA → /hola/inbox.
//  • còn lại: /dashboard.
export function landingPathFor(role: string | null | undefined, tenant: { holaEnabled?: boolean } | null | undefined): string {
  if (role === 'ctv') return '/timeline';
  if (tenant?.holaEnabled === true) return '/hola/inbox';
  return '/dashboard';
}
